import ErrorOutlineRoundedIcon from "@mui/icons-material/ErrorOutlineRounded";
import { Box } from "@mui/material";
import React from "react";

const formatFailedAt = (failedAt) => {
    const time = failedAt ? new Date(failedAt) : null;
    return time && !Number.isNaN(time.getTime())
        ? time.toLocaleString(undefined, { dateStyle: "medium", timeStyle: "short" })
        : null;
};

const MetaItem = ({ children }) => (
    <Box
        component="span"
        sx={{
            px: 0.75,
            py: 0.125,
            borderRadius: 1,
            bgcolor: "rgba(211, 47, 47, 0.08)",
            color: "#7A1F1F",
            fontVariantNumeric: "tabular-nums",
            whiteSpace: "nowrap",
        }}
    >
        {children}
    </Box>
);

// Why a task failed, attached beneath that task's row on the admin actions page.
const TaskFailureNotice = ({ failure }) => {
    // The reference lets support find the raw error in the service logs.
    const meta = [
        failure.service,
        formatFailedAt(failure.failedAt),
        failure.reference && `Reference ${failure.reference}`,
    ].filter(Boolean);

    return (
        <Box
            role="alert"
            sx={{
                display: "flex",
                gap: 1.5,
                alignItems: "flex-start",
                textAlign: "left",
                px: 2,
                py: 1.5,
                borderRadius: "10px",
                border: "1px solid rgba(211, 47, 47, 0.22)",
                borderLeft: "3px solid",
                borderLeftColor: "error.main",
                bgcolor: "#FEF6F6",
            }}
        >
            <ErrorOutlineRoundedIcon
                aria-hidden
                sx={{ color: "error.main", fontSize: 20, mt: "1px", flexShrink: 0 }}
            />
            <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5, minWidth: 0 }}>
                <Box sx={{ fontSize: 14, fontWeight: 600, color: "#5F1414", lineHeight: 1.4 }}>
                    {failure.title}
                </Box>
                {failure.detail && (
                    <Box
                        sx={{
                            fontSize: 13,
                            color: "text.secondary",
                            lineHeight: 1.5,
                            overflowWrap: "anywhere",
                        }}
                    >
                        {failure.detail}
                    </Box>
                )}
                {meta.length > 0 && (
                    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.75, mt: 0.25, fontSize: 12 }}>
                        {meta.map((item) => (
                            <MetaItem key={item}>{item}</MetaItem>
                        ))}
                    </Box>
                )}
            </Box>
        </Box>
    );
};

export default TaskFailureNotice;
